import DropdownStore from './DropdownStore';
import { setActiveDataToObject } from './util';
import { IItem, ActiveDataObjType, IDropdownSelectConfig, StateType } from "../interface/IDropdown";

class DropdownSelect {
    private selectEle: HTMLSelectElement | null = null;
    private data: IItem[];
    private changeCallback: ((curVal: ActiveDataObjType) => any) | null;
    private store: DropdownStore;
    private isInitialCallbackCall: boolean;

    constructor({ data, parent, isInitialCallbackCall, changeCallback, store }: IDropdownSelectConfig) {
        this.data = data;
        this.changeCallback = changeCallback;
        this.store = store;
        this.isInitialCallbackCall = isInitialCallbackCall;

        this.init(parent);
    }

    private init(parent: Element) {
        parent?.insertAdjacentHTML('beforeend', this.template());
        this.selectEle = parent.querySelector('.dropdown-select');

        this.addEvent();

        this.store.addListener('activeKey', (activeKey: string) => {
            const isInitial = this.store.state.isInitial;

            this.setValue(activeKey);
            if((isInitial && this.isInitialCallbackCall) || !isInitial) {
                typeof this.changeCallback === 'function' && this.changeCallback(setActiveDataToObject(this.store.state.activeData));
            }
        });
    }

    private template() {
        let optionTmpl =  '';

        this.data.forEach((v, i) => {
            optionTmpl += `<option value="${v?.value || ''}" data-key="${i}">${v?.title || ''}</option>`;
        });

        return `<div class="dropdown-select-wrap">
            <select class="dropdown-select">
                ${optionTmpl}
            </select>
            <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" class="dropdown-select-icon" width="16" height="16" viewBox="0 0 16 16">
                <path d="m3.76 6.23.7-.7L8 9.06l3.54-3.53.7.7L8 10.47 3.76 6.23z"></path>
            </svg>
        </div>`;
    }

    private addEvent() {
        this.selectEle?.addEventListener('change', (e: Event) => {
            const target = e.target as HTMLSelectElement;
            const value = target?.value;
            const key = this.selectEle?.querySelector(`option[value="${value}"]`)?.getAttribute('data-key') || null;
            this.store.dispatch<'activeKey', StateType['activeKey']>('activeKey', key);
        });
    }

    public setValue(key: string) {
        const value = this.selectEle?.querySelector(`option[data-key="${key}"]`)?.getAttribute('value') || '';
        if(this.selectEle) {
            this.selectEle.value = value;
        }
    }
}

export default DropdownSelect;